import { useAppSelector } from '@store/hooks';
import { selectGlobal } from '@store/slices/global/global';
import { tabNameSetter } from '@utils/storage';
import { getNewAbilities } from '@src/utils';
import { useGetPermissions } from '@hooks/useGetPermissions';
import { selectUsers } from '@store/slices/users/usersSlice';

export const useSupervisorAccess = () => {
  const { newPermissions } = useAppSelector(selectUsers);
  const { currentPath } = useAppSelector(selectGlobal);

  const exceptionPermissions =
    currentPath === 'home'
      ? newPermissions.find((el) => el.name === 'Members').permissions
      : newPermissions;
  const adjustedPath = tabNameSetter.getTabName();
  const supervisorDocuments = getNewAbilities(
    adjustedPath,
    exceptionPermissions
  );
  const supervisorPermissions = useGetPermissions(
    supervisorDocuments?.abilities
  );

  return { supervisorPermissions };
};
